export default {
    titulo: "Branches",
    nueva: "New branch",
    eliminar: "Delete branch",
    pregEliminar: "Are you sure you want to delete the branch?",
    editar: "Edit branch",
    tituloPadrones: "Records (nomenclature or cadastral registry)",
    nuevoPadron: "New record",
    editarPadron: "Edit record",
    eliminarPadron: "Delete record",
    pregEliminarPadron: "Are you sure you want to delete the record?",
    nroPadron: "Record number",
    propietario: "Owner",
    nroServicioLuz: "Electric service number",
    kwContratados: "Contracted KW",
    nroServicioAgua: "Water service number",
    diametroConexion: "Connection diameter"
}
